import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PinFilledSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3541 16.72L15.0656 14.701L19.9239 9.84402L21.7272 11.6468L23 10.3744L13.6229 1L12.3501 2.27242L14.1534 4.07521L9.29506 8.93215L7.27545 8.64371C5.36831 8.37132 3.44419 9.0125 2.08195 10.3743L1 11.456L6.13914 16.5936L1.00366 21.7276L2.27645 23L7.41193 17.866L12.541 22.9936L13.6229 21.912C14.9852 20.5501 15.6266 18.6266 15.3541 16.72Z", fill: "var(--magritte-ui-icon-color)" }) }));
const PinFilledSize24 = hoc(forwardRef(PinFilledSize24Component), 'PinFilledSize24');

export { PinFilledSize24 as default };
//# sourceMappingURL=PinFilledSize24.js.map
